<template>
  <v-card
    v-if="true"
    flat
  >
    <v-card-title>
      <div class="selection-fields">
        <button
          v-for="(item, i) in options"
          :key="i"
          class="title font-weight-light mb-1"
          :class="{active : getClass(item)}"
          large
          @click="(event)=> updateSection(item, event)"
        >
          {{ item }}
        </button>
      </div>
      <v-spacer />
      <slot name="actions" />
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
  <div
    v-else
    class="mb-5"
  >
    <div class="title mb-3">
      <h2>
        {{ title }}
      </h2>
      <template v-if="$slots.actions">
        <v-spacer />
        <slot name="actions" />
      </template>
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  name      : 'ContentMultiSection',
  components: { },
  props     : {
    options        : { type: Array, default: undefined },
    onChangeSection: { type: Function },
  },
  data   : () => ({ active: 'Game Develop' }),
  methods: {
    getClass (item) {
      return item === this.active
    },
    updateSection (nextSection, e) {
      this.active = nextSection
      this.onChangeSection(nextSection)
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.selection-fields{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20vh;
}
.active{
  background-color: #424242;
  color: white;
  padding: 5px;
  text-shadow: -3px -2px 6px white;
}
</style>
